<template>
	<nk-box v-if="context != null && context.length > 0" variant="sidebar">
		<nk-title size="lg">
			{{ options.title || 'Das könnte Sie auch interessieren' }}
		</nk-title>

		<nk-row vertical-gutter="3">
			<nk-col
				v-for="(veranstaltung, index) in context"
				:key="index"
				cols="full"
			>
				<nk-link
					v-if="getDetailURL(veranstaltung.rubriken)"
					:link="getDetailURL(veranstaltung.rubriken)"
				>
					<nk-meta size="md" variant="normal" no-margin>
						{{ veranstaltung.titel }}
					</nk-meta>
				</nk-link>
				<nk-meta v-else size="md" variant="normal" no-margin>
					{{ veranstaltung.titel }}
				</nk-meta>
				<div class="flex">
					<nk-icon icon="date" class="mr-1" />
					{{ getDateTimeString(veranstaltung.datum_von) }}
					<template
						v-if="
							$moment(veranstaltung.datum_bis)
								.startOf('day')
								.isAfter($moment(veranstaltung.datum_von).startOf('day'))
						"
					>
						-
						{{ getDateTimeString(veranstaltung.datum_bis) }}
					</template>
				</div>
			</nk-col>
		</nk-row>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {object} options
 * @prop {Boolean} options.title
 */
export default {
	name: 'NkSidebarVeranstaltungen',

	mixins: [TemplatesDefault],

	methods: {
		getDateTimeString(object) {
			return this.$formatTime(object);
		},
		getDetailURL(rubriken) {
			if (rubriken.length && rubriken[0].detailURL) {
				return rubriken[0].detailURL;
			}

			return '';
		},
	},
};
</script>
